module.exports = __webpack_public_path__ + "img/check.4b877311.svg";